var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconFurnishings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2888_3971)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2888_3971",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2888_3971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2382 16.8579H25.2099V16.5158C25.2099 15.4873 24.3731 14.6505 23.3446 14.6505H21.8396V10.5563H27.3004C27.6917 10.5563 28.0524 10.3766 28.2898 10.0629C28.5285 9.74766 28.6041 9.34875 28.4961 8.96492L26.1725 0.903359C26.0242 0.371406 25.5316 0 24.9756 0H15.0244C14.4683 0 13.9758 0.371406 13.8288 0.898438L11.5021 8.96953C11.3953 9.34977 11.4715 9.74867 11.7107 10.0639C11.9482 10.377 12.3083 10.5565 12.6995 10.5565H18.1646V14.6507H16.6545C15.6261 14.6507 14.7899 15.4875 14.7899 16.5159V16.858H5.76168C5.07504 16.858 4.5166 17.4166 4.5166 18.1031V19.8887C4.5166 20.575 5.07512 21.1335 5.76168 21.1335H6.90973V39.3751C6.90973 39.7202 7.18934 40.0001 7.53473 40.0001H10.5603C10.9057 40.0001 11.1853 39.7202 11.1853 39.3751V36.9746H28.814V39.3751C28.814 39.7202 29.0936 40.0001 29.439 40.0001H32.4651C32.8106 40.0001 33.0901 39.7202 33.0901 39.3751V21.1334H34.2382C34.9248 21.1334 35.4832 20.5748 35.4832 19.8885V18.103C35.4834 17.4164 34.9249 16.8579 34.2382 16.8579ZM15.0244 1.25L24.9701 1.24445L27.2919 9.30633L12.7045 9.31086L15.0244 1.25ZM19.4146 10.5562H20.5895V14.6505H19.4146V10.5562ZM16.04 16.5158C16.04 16.1765 16.3158 15.9005 16.6546 15.9005H23.3446C23.6839 15.9005 23.9599 16.1764 23.9599 16.5158V16.8579H16.04V16.5158ZM32.4652 19.8834C32.1197 19.8834 31.8402 20.1633 31.8402 20.5084V38.75H30.064V36.3495C30.064 36.0044 29.7844 35.7245 29.439 35.7245H10.5602C10.2147 35.7245 9.9352 36.0044 9.9352 36.3495V38.75H8.15973V20.5084C8.15973 20.1633 7.88012 19.8834 7.53473 19.8834L5.76652 19.8886L5.76168 18.1079L34.2334 18.1073L34.2382 19.8834H32.4652ZM29.9847 19.8834H10.0146C9.6691 19.8834 9.38957 20.1633 9.38957 20.5084C9.38957 24.9927 9.38957 28.8459 9.38957 33.3301C9.38957 33.6752 9.66918 33.9551 10.0146 33.9551H29.9847C30.3302 33.9551 30.6097 33.6752 30.6097 33.3301C30.6097 28.8458 30.6097 24.9927 30.6097 20.5084C30.6097 20.1633 30.3302 19.8834 29.9847 19.8834ZM10.6396 21.1334H29.3598V26.2942H10.6396V21.1334ZM29.3597 32.7051H10.6396V27.5442H29.3598L29.3597 32.7051Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2888_3971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconFurnishings);
export default __webpack_public_path__ + "static/media/Home-Icon-Furnishings.cd7ebbe6583ab67cb783f5ebb52bab51.svg";
export { ForwardRef as ReactComponent };